var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletAmico({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 267.938,
    height: 256.393,
    viewBox: "0 0 267.938 256.393",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    d: "M367.974,326.4V336.1c0,.727-.509,1.023-1.141.662l-10.191-5.808a2.52,2.52,0,0,1-1.142-1.975v-9.706c0-.727.515-1.023,1.142-.656,2.78,1.6,7.411,4.2,10.191,5.8A2.519,2.519,0,0,1,367.974,326.4Z",
    transform: "translate(-355.5 -318.464)",
    fill: "#455a64"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wallet-amico",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-1",
    transform: "translate(0 94.336)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-1-2",
    "data-name": "freepik--floor--inject-1",
    cx: 132.408,
    cy: 81.028,
    rx: 132.408,
    ry: 81.028,
    transform: "translate(0 0)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-1",
    transform: "translate(0.869 90.657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-1-2",
    "data-name": "freepik--plants--inject-1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2093",
    "data-name": "Path 2093",
    d: "M55.817,247.058l4.732-2.573s2.5-12.3,1.053-22.96c-2.04-14.975-12.1-20.346-15.821-18.926s-4.684,5.808,1.774,14.579C51.405,222.341,56.237,233.206,55.817,247.058Z",
    transform: "translate(-33.827 -202.379)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(9.015)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2094",
    "data-name": "Path 2094",
    d: "M55.817,247.058l4.732-2.573s2.5-12.3,1.053-22.96c-2.04-14.975-12.1-20.346-15.821-18.926s-4.684,5.808,1.774,14.579C51.405,222.341,56.237,233.206,55.817,247.058Z",
    transform: "translate(-42.842 -202.379)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2095",
    "data-name": "Path 2095",
    d: "M61.486,242.6h-.047a.331.331,0,0,1-.3-.367c1.5-14.035-4.584-29.17-11.09-35.15a.331.331,0,0,1,0-.467.337.337,0,0,1,.473,0c6.6,6.062,12.8,21.446,11.285,35.676A.331.331,0,0,1,61.486,242.6Z",
    transform: "translate(-36.733 -204.069)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2096",
    "data-name": "Path 2096",
    d: "M38.66,268.868c-.7.485-2.295-.325-2.9-.668a7.061,7.061,0,0,1-2.543-2.5,6.607,6.607,0,0,1-.893-3.915,15.494,15.494,0,0,1,.337-2.141c.142-.692.29-1.39.432-2.088a5.175,5.175,0,0,0,.136-2.082c-.284-1.384-1.6-2.265-2.792-3.022-1.319-.834-2.709-1.964-2.833-3.649a5.914,5.914,0,0,1,1.183-3.631c.722-1.082,1.609-2.052,2.248-3.188a4.081,4.081,0,0,0,.645-2.673,4.335,4.335,0,0,0-.662-1.573,22.945,22.945,0,0,1-2.041-3.135,3.336,3.336,0,0,1,.3-3.549,3.868,3.868,0,0,1,2.833-.94,6.636,6.636,0,0,1,2.768.739c2.78,1.278,4.548,4.323,7.47,5.246a28.617,28.617,0,0,0,3.49.591,4.128,4.128,0,0,1,2.957,1.715c1.183,1.993-.532,4.7.373,6.849.8,1.9,2.75,2.5,3.951,4.182a4.2,4.2,0,0,1,.71,2.5,12.3,12.3,0,0,1-.745,4.394,34.827,34.827,0,0,1-1.585,3.59C51.453,259.96,38.766,268.8,38.66,268.868Z",
    transform: "translate(-27.599 -213.709)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2097",
    "data-name": "Path 2097",
    d: "M49.5,265.655h0a.331.331,0,0,1-.349-.319c-.473-13.237-7.813-27.319-12.657-31.2a.333.333,0,1,1,.414-.52c4.945,3.963,12.42,18.282,12.911,31.7A.337.337,0,0,1,49.5,265.655Z",
    transform: "translate(-31.182 -215.109)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2098",
    "data-name": "Path 2098",
    d: "M46.187,260.715a.2.2,0,0,1-.1,0,45.005,45.005,0,0,0-9.694-.8.331.331,0,0,1-.343-.319.319.319,0,0,1,.319-.343,45.3,45.3,0,0,1,9.865.816.337.337,0,0,1,.248.4A.319.319,0,0,1,46.187,260.715Z",
    transform: "translate(-31.051 -225.606)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-1-3",
    "data-name": "freepik--plants--inject-1",
    transform: "translate(240.361 1.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    "data-name": "Path 2099",
    d: "M442.745,255.628l-5.5-3.484a116.756,116.756,0,0,1-3.188-19.666c-.692-13.012,4.306-29.762,14.745-27.644s-1.993,17.383-3.549,28.756S442.745,255.628,442.745,255.628Z",
    transform: "translate(-433.993 -204.652)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    d: "M442.745,255.628l-5.5-3.484a116.756,116.756,0,0,1-3.188-19.666c-.692-13.012,4.306-29.762,14.745-27.644s-1.993,17.383-3.549,28.756S442.745,255.628,442.745,255.628Z",
    transform: "translate(-433.993 -204.652)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    d: "M442.338,257.57h0a.337.337,0,0,0,.272-.39c-5.323-28.39,6.7-44.861,6.819-45.027a.337.337,0,1,0-.538-.4c-.124.166-12.308,16.9-6.944,45.542a.337.337,0,0,0,.39.278Z",
    transform: "translate(-436.686 -207.487)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2102",
    "data-name": "Path 2102",
    d: "M450.7,268.852l-4.14-2.366a42.693,42.693,0,0,1,.657-18.057c2.147-9.079,9.635-17.483,14.195-16.649s4.9,3.909,3.283,7.434S451.228,252.664,450.7,268.852Z",
    transform: "translate(-438.863 -215.712)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    d: "M450.125,269.6h0a.337.337,0,0,0,.284-.385c-2.821-18.015,12.249-32.772,12.42-32.92a.337.337,0,0,0,0-.479.343.343,0,0,0-.479,0c-.154.148-15.472,15.153-12.6,33.511A.337.337,0,0,0,450.125,269.6Z",
    transform: "translate(-440.285 -217.343)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-1",
    transform: "translate(36.664 139.174)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-1",
    cx: 47.079,
    cy: 27.183,
    rx: 47.079,
    ry: 27.183,
    transform: "translate(0 25.042)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-1-2",
    "data-name": "freepik--shadow--inject-1",
    d: "M290.38,373.441a5.7,5.7,0,0,1-4.14-1.686l-59.547-62.374a13.97,13.97,0,0,1-3.963-9.646,13.345,13.345,0,0,1,.136-1.881,13.81,13.81,0,0,1,6.914-9.978l1.774-1.023a20.506,20.506,0,0,1,19.411,0l83.495,48.179,4.43,2.526a3.289,3.289,0,0,1,0,6.015l-5.288,3.01a8.47,8.47,0,0,1-4.075.976h0a7.79,7.79,0,0,1-2.774-.473l-71.477-27.9,42.88,44.9a3.951,3.951,0,0,1-.952,6.358l-4.14,2.33a5.43,5.43,0,0,1-2.685.668Z",
    transform: "translate(-143.115 -284.41)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1",
    transform: "translate(17.764 1.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-1-2",
    "data-name": "freepik--character--inject-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    "data-name": "Path 2104",
    d: "M174.4,108.827c5.435-.367,8.067,1.4,10.4,4.223s13.337,22.581,13.337,22.581,22.824.591,27.171,1.964,6.808,3.827,7.689,5.323a7.457,7.457,0,0,1,.509,5.778c-.591,2.437-3.909,1.928-5.69,0a23.066,23.066,0,0,0-5.625-4.412c-1.863-1.053-20.287.248-25.3.3s-5.956-2.029-9.031-6.192-9.717-13.869-9.717-13.869Z",
    transform: "translate(-104.47 -75.05)",
    fill: "#b16668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    d: "M171.64,108.62c4.885-.4,8.132-.1,10.936,2.6s12.344,19.79,12.344,19.79-1.319,5.406-9.41,6.6l-12.237-16.4Z",
    transform: "translate(-103.342 -74.926)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-1-3",
    "data-name": "freepik--character--inject-1",
    transform: "translate(41.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Botom--inject-1",
    transform: "translate(0 76.592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M129.172,352.148a7.67,7.67,0,0,0,6.89.2l1.668-13.521-8.73-2Z",
    transform: "translate(-127.588 -244.812)",
    fill: "#b16668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M171.53,340.813c1.65,3.874,4.063,2.608,7.73.272l.242-13.355-9.463-.651Z",
    transform: "translate(-144.355 -240.829)",
    fill: "#b16668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    d: "M142.949,376.052a3.746,3.746,0,0,1-.136,2.295,6.306,6.306,0,0,1-4.607,1.816,11.336,11.336,0,0,1-6.66-1.372,4.56,4.56,0,0,1-2.366-3.732c-.071-1.544.112-3.022-.591-4.229-.645-1.112-1.52-2.206-1.733-2.8a7.719,7.719,0,0,1-.095-3.306Z",
    transform: "translate(-126.615 -256.207)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    d: "M136.068,359.934a7.307,7.307,0,0,0,.278,1.721,15.443,15.443,0,0,0,1.556,3.43,14.068,14.068,0,0,0,1.076,1.626c.793.994,1.774,1.822,2.62,2.78a5.536,5.536,0,0,1,1.567,3.389c.053,2.123-2.271,2.774-4.051,3.034a13.011,13.011,0,0,1-5.743-.455,5.282,5.282,0,0,1-3.744-4.341c-.083-.591-.03-1.183-.083-1.774a8.351,8.351,0,0,0-1.532-3.756,10.959,10.959,0,0,1-1.183-2.058c-.515-1.325,0-2.786.367-4.081.337-1.124.591-2.466.988-2.366v.722c.118.254.408.426.479.716a5.144,5.144,0,0,0,.3.881,2.318,2.318,0,0,0,.911,1.065c.047-.8.1-1.6.148-2.4a.846.846,0,0,1,.893-.976,15.055,15.055,0,0,1,4.542-.237.858.858,0,0,1,.591.284.887.887,0,0,1,.083.544A20.747,20.747,0,0,0,136.068,359.934Z",
    transform: "translate(-126.613 -252.965)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    d: "M141.146,370.371a6.176,6.176,0,0,0-3.507-.591,5.773,5.773,0,0,0-2.774.881.639.639,0,0,1-.81-.089h0a.591.591,0,0,1,.089-.9,5.985,5.985,0,0,1,3.123-1.053,6.3,6.3,0,0,1,3.07.331S141.4,369.673,141.146,370.371Z",
    transform: "translate(-129.585 -257.795)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    d: "M143.892,374.164A7.884,7.884,0,0,0,140,373.65a5.56,5.56,0,0,0-2.7.934.621.621,0,0,1-.8-.083h0a.591.591,0,0,1,.083-.9,6.115,6.115,0,0,1,3.194-1.142c2.366-.1,2.993.4,2.993.4A1.981,1.981,0,0,1,143.892,374.164Z",
    transform: "translate(-130.58 -259.364)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    d: "M135.794,364.68a5.879,5.879,0,0,1,2.957.343c.408.248.668.917.39,1.076a5.5,5.5,0,0,0-2.638-.444,7.832,7.832,0,0,0-2.591.633c-.207.083-.455.2-.668.313a.591.591,0,0,1-.775-.266h0a.532.532,0,0,1,.225-.674A7.688,7.688,0,0,1,135.794,364.68Z",
    transform: "translate(-128.988 -256.167)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    d: "M192.834,361.547a2.573,2.573,0,0,1-.16,1.881c-.284.544-3.212,2.082-7.1,1.7a16.17,16.17,0,0,1-7.955-3.046,9.2,9.2,0,0,0-4.909-1.419c-1.952-.166-4.418-1.183-4.814-2.117a4.23,4.23,0,0,1,.136-2.449Z",
    transform: "translate(-143.42 -252.685)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    d: "M177.473,344.507l1.023-.337a.84.84,0,0,1,.591-.053c.248.1.337.4.39.656a10.055,10.055,0,0,0,.379,1.7,4.141,4.141,0,0,0,1.053,1.183,17.926,17.926,0,0,0,3.052,2.1c1.248.716,2.478,1.283,3.773,1.91a36.214,36.214,0,0,1,4.1,1.774,2.8,2.8,0,0,1-.154,4.631,13.723,13.723,0,0,1-9.6.378c-2.23-.7-4.661-3.188-7.612-3.507-1.875-.2-5.418-.84-6.589-2.3-.426-.651.231-2.638.775-4.359.591-1.875.893-4.909,1.514-4.732.1,1.005.55,1.094.864,1.632a11.433,11.433,0,0,1,.633,1.52,2.685,2.685,0,0,0,.94,1.325,1.248,1.248,0,0,0,1.526-.041c.591-.556.272-1.567.7-2.242a2.324,2.324,0,0,1,1.349-.828Z",
    transform: "translate(-143.419 -247.557)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2115",
    "data-name": "Path 2115",
    d: "M188.757,351.525a1.733,1.733,0,0,0-1.36-.97,5.023,5.023,0,0,0-3.342,1.147.7.7,0,0,0,.065,1.183h0a.7.7,0,0,0,.8-.065,5.376,5.376,0,0,1,3.833-1.3Z",
    transform: "translate(-149.96 -250.405)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2116",
    "data-name": "Path 2116",
    d: "M192.793,354.243a2,2,0,0,0-1.621-.893,6.283,6.283,0,0,0-3.655,1.242.686.686,0,0,0,.059,1.124h0a.668.668,0,0,0,.775-.065A5.388,5.388,0,0,1,192.793,354.243Z",
    transform: "translate(-151.388 -251.562)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    d: "M197.74,356.706a2.271,2.271,0,0,0-1.686-.816,6.027,6.027,0,0,0-3.507,1.266.686.686,0,0,0,.059,1.124h0a.668.668,0,0,0,.775-.065A5.151,5.151,0,0,1,197.74,356.706Z",
    transform: "translate(-153.443 -252.599)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    "data-name": "Path 2118",
    d: "M132.028,184.26c-.929,14.822-2.437,51.911-2.437,51.911-.207,1.839-.887,7.275-1.224,13.917-.491,9.635.278,30.9.278,30.9a10.4,10.4,0,0,0,8.221.651s5.483-31.347,7.233-40.81c1.544-8.316,4.542-28.39,4.542-28.39l1.408,24.652a78.66,78.66,0,0,0,.325,13.248c.55,4.394,3.064,23.469,3.064,23.469a16.9,16.9,0,0,0,8.972-.083s1.313-31.986,1.508-36.037c.225-4.613,1.183-56.442,1.183-56.442Z",
    transform: "translate(-127.263 -181.25)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2119",
    "data-name": "Path 2119",
    d: "M162.76,223.183l2.555-12.089s6.1-.349,9.558-3.643c0,0-.692,3.306-8.4,5.075l-2.561,12.237-.254,11.4Z",
    transform: "translate(-141.381 -191.954)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2120",
    "data-name": "Path 2120",
    d: "M136.258,110.524c-2.91.515-3.105,1.958-3.744,4.85a23.634,23.634,0,0,0-.739,7.1l1.5,17.211-.591,19.553c4.69,5.1,23.936,6.725,34.174-.751,0,0-.112-32.317-.591-37.5-.822-9.061-4.933-12.278-10.96-12.261l-10.315.881Z",
    transform: "translate(-128.695 -75.026)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2121",
    "data-name": "Path 2121",
    d: "M136.258,110.524c-2.91.515-3.105,1.958-3.744,4.85a23.634,23.634,0,0,0-.739,7.1l1.5,17.211-.591,19.553c4.69,5.1,23.936,6.725,34.174-.751,0,0-.112-32.317-.591-37.5-.822-9.061-4.933-12.278-10.96-12.261l-10.315.881Z",
    transform: "translate(-128.695 -75.026)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2122",
    "data-name": "Path 2122",
    d: "M157.83,66.655a9.156,9.156,0,1,0,9.12-9.185A9.156,9.156,0,0,0,157.83,66.655Z",
    transform: "translate(-139.367 -54.088)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2123",
    "data-name": "Path 2123",
    d: "M149.26,72.427l-1.952-5.252a3.436,3.436,0,0,0-2.839,1.011c-1.218,1.254-.526,5.157,1.011,8.984,0,0,1.508,6.961,2.106,8.109a3.147,3.147,0,0,0,1.828,1.461Z",
    transform: "translate(-133.654 -58.044)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2124",
    "data-name": "Path 2124",
    d: "M148.283,74.507c-.556.337-1.36-.733-2.052-1.455a2.435,2.435,0,0,0-4.075.674c-1.118,2.378,1.017,5.6,2.792,6.157,3.064.946,3.5-1.005,3.5-1.005l.272,11.042a9.838,9.838,0,0,0,7.446,5.613c5.43.716,4.3-3.756,2.508-5.914V86.254a19.287,19.287,0,0,0,4.14.2c2.247-.355,3.655-2.135,4.329-4.578,1.088-3.915,1.49-7.1.532-14.786-1.047-8.434-10.859-8.487-16.147-5.134S148.283,74.507,148.283,74.507Z",
    transform: "translate(-132.837 -55.073)",
    fill: "#b16668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2125",
    "data-name": "Path 2125",
    d: "M151.112,71.925c-.887-.254-1.532-1.668-2.111-2.194-.97-.875.248-8.872.248-8.872a3.769,3.769,0,0,1,.917-4.028c1.319-1.461,3.549-1.632,7.31-2.242,1.863-.3,4.057-.444,5.914-.787a18.784,18.784,0,0,0,5.495-1.774,1.656,1.656,0,0,1,1.047-.272.988.988,0,0,1,.662.556,1.881,1.881,0,0,1,.154.869,3.465,3.465,0,0,1-.16.917c-.059.177-.42.716-.343.869.189.384,1.644-.26,1.934-.349a.225.225,0,0,1,.331.124,3.549,3.549,0,0,1-.172,3.064,10.362,10.362,0,0,1-5.2,4.424,14.289,14.289,0,0,1-7.1.982,13.6,13.6,0,0,1-3.022-.668,8.414,8.414,0,0,1-.662,1.035,4.643,4.643,0,0,1-.976.858,4.175,4.175,0,0,1-1.183.544c-.432.112-.846.059-1.082.526a2.259,2.259,0,0,0-.177.976l-.089,2.922a4.732,4.732,0,0,1-.2,1.473,1.62,1.62,0,0,1-.988,1.035.958.958,0,0,1-.556.012Z",
    transform: "translate(-135.606 -51.751)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2126",
    "data-name": "Path 2126",
    d: "M163.927,101.448s-5.027-.994-6.79-1.922A5.79,5.79,0,0,1,154.7,97.16a8,8,0,0,0,1.39,2.833c1.289,1.638,7.843,2.821,7.843,2.821Z",
    transform: "translate(-138.088 -70.303)",
    fill: "#9a4a4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    d: "M167.281,82.029A1.005,1.005,0,1,1,166.293,81a1.023,1.023,0,0,1,.988,1.029Z",
    transform: "translate(-142.407 -63.701)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2128",
    "data-name": "Path 2128",
    d: "M164.957,77.047l-2.23,1.449a1.4,1.4,0,0,1,.408-1.887,1.3,1.3,0,0,1,1.822.438Z",
    transform: "translate(-141.283 -61.824)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2129",
    "data-name": "Path 2129",
    d: "M165.706,93.09l3.549,1.514a1.958,1.958,0,0,1-2.6,1.035,1.869,1.869,0,0,1-.946-2.549Z",
    transform: "translate(-142.506 -68.64)",
    fill: "#9a4a4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2130",
    "data-name": "Path 2130",
    d: "M166.691,96.505a2.212,2.212,0,0,0,.869.16,1.7,1.7,0,0,0-1.674-1.455,1.361,1.361,0,0,0-.266.03,1.81,1.81,0,0,0,1.071,1.266Z",
    transform: "translate(-142.549 -69.506)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2131",
    "data-name": "Path 2131",
    d: "M182.353,77.916l-2.123-1.289a1.183,1.183,0,0,1,1.668-.45A1.307,1.307,0,0,1,182.353,77.916Z",
    transform: "translate(-148.518 -61.658)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2132",
    "data-name": "Path 2132",
    d: "M181.061,82.023A1.005,1.005,0,1,1,180.05,81a1.023,1.023,0,0,1,1.011,1.023Z",
    transform: "translate(-148.036 -63.701)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2133",
    "data-name": "Path 2133",
    d: "M173.48,81.85l.16,6.482,3.413-1.053Z",
    transform: "translate(-145.761 -64.048)",
    fill: "#9a4a4d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2134",
    "data-name": "Path 2134",
    d: "M96.936,141.327c3-4.732,7.31-13.491,7.31-13.491,2.449-5.82,2.295-12.42.982-16.016a23.068,23.068,0,0,0-2.419.467c-4.14,1.183-5.323,1.774-7.358,5.211-1.609,2.721-6.819,16.33-8.824,20.565l-9.777-8.872c-2.313-2.295-2.65-5.323-4.022-7.316s-3.04-2.632-4.637-4.347-2.141-2.957-2.9-1.733.923,3.679,1.183,4.264,2.141,2.111-.532,1.68-7.435-4.14-8.617-4.879-1.4.822-.94,1.9-.065,3.856.71,5.648a7.76,7.76,0,0,0,3.626,4.276c2.159,1.425,6.985,2.715,9.185,4.732s7.375,8.564,10.522,12.515c4,5.021,7.523,7.346,10.782,3.655A67.2,67.2,0,0,0,96.936,141.327Z",
    transform: "translate(-56.165 -76.293)",
    fill: "#b16668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2135",
    "data-name": "Path 2135",
    d: "M127.608,111.6c-3.318-.2-8.736.106-11.728,6.689s-7.239,17.371-7.239,17.371,5.039,6.66,10.5,6.062l8.239-15.62S129.749,117.908,127.608,111.6Z",
    transform: "translate(-77.604 -76.188)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wallet--inject-1",
    transform: "translate(121.01 66.226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--wallet--inject-1-2",
    "data-name": "freepik--wallet--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2136",
    "data-name": "Path 2136",
    d: "M403.08,327.309a1.774,1.774,0,0,0,.751-1.656v-71.76a5.235,5.235,0,0,0-.751-2.525l4.448-2.567a5.229,5.229,0,0,1,.751,2.52v71.766a1.774,1.774,0,0,1-.751,1.656Z",
    transform: "translate(-301.144 -196.914)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2137",
    "data-name": "Path 2137",
    d: "M335.726,218.585a5.223,5.223,0,0,0-1.81-1.91L252.7,169.784a11.326,11.326,0,0,0-10.244,0l-1.774,1.023a4.554,4.554,0,0,0-2.466,3.927v77.681a4.572,4.572,0,0,1,2.466-3.933l1.774-1.023a11.326,11.326,0,0,1,10.244,0l81.2,46.89a1.561,1.561,0,0,0,2.561-1.479V221.11a5.234,5.234,0,0,0-.739-2.525Z",
    transform: "translate(-233.79 -164.132)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2138",
    "data-name": "Path 2138",
    d: "M235.385,173.006a4.394,4.394,0,0,1,2.248-5.258l1.774-1.023a11.326,11.326,0,0,1,10.244,0l81.194,46.89a5.24,5.24,0,0,1,1.81,1.91l4.448-2.567a5.323,5.323,0,0,0-1.81-1.916l-83.43-48.156a15.754,15.754,0,0,0-14.68,0l-1.774,1.017a9.126,9.126,0,0,0-4.59,6.589,8.218,8.218,0,0,0-.089,1.183,9.262,9.262,0,0,0,2.656,6.376l3.212-3.064a5.2,5.2,0,0,1-1.213-1.975",
    transform: "translate(-230.73 -161.073)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2139",
    "data-name": "Path 2139",
    d: "M333,233.25v-9.836l-81.567-47.079a5.518,5.518,0,0,0-5.122,0l-.887.509a2.277,2.277,0,0,0-1.23,1.964v17.016Z",
    transform: "translate(-236.229 -167.05)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2140",
    "data-name": "Path 2140",
    d: "M333,233.25v-9.836l-81.567-47.079a5.518,5.518,0,0,0-5.122,0l-.887.509a2.277,2.277,0,0,0-1.23,1.964v17.016Z",
    transform: "translate(-236.229 -167.05)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2141",
    "data-name": "Path 2141",
    d: "M251,172.9a7.9,7.9,0,0,0-7.34,0l-.881.509a4.56,4.56,0,0,0-2.3,3.277,4.137,4.137,0,0,0-.041.591v2.662l2.218,2.318v-4.933a2.271,2.271,0,0,1,1.23-1.964l.887-.509a5.66,5.66,0,0,1,5.122,0l81.567,47.079,2.224-1.283Z",
    transform: "translate(-234.697 -165.533)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2142",
    "data-name": "Path 2142",
    d: "M251,172.9a7.9,7.9,0,0,0-7.34,0l-.881.509a4.56,4.56,0,0,0-2.3,3.277,4.137,4.137,0,0,0-.041.591v2.662l2.218,2.318v-4.933a2.271,2.271,0,0,1,1.23-1.964l.887-.509a5.66,5.66,0,0,1,5.122,0l81.567,47.079,2.224-1.283Z",
    transform: "translate(-234.697 -165.533)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2143",
    "data-name": "Path 2143",
    d: "M394.34,255.483l2.224-1.283v12.243l-2.224-1.319Z",
    transform: "translate(-297.573 -199.12)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2144",
    "data-name": "Path 2144",
    d: "M394.34,255.483l2.224-1.283v12.243l-2.224-1.319Z",
    transform: "translate(-297.573 -199.12)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2145",
    "data-name": "Path 2145",
    d: "M337.755,295.194V239.941l-81.342-47.008a5.506,5.506,0,0,0-5.495,0l-2.058,1.183v52.71l86.351,49.847a1.709,1.709,0,0,0,2.543-1.479Z",
    transform: "translate(-238.137 -173.789)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Card--inject-1",
    transform: "translate(15.691 16.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--card--inject-1-2",
    "data-name": "freepik--card--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2146",
    "data-name": "Path 2146",
    d: "M333.279,291.661l1.4-.8a1.774,1.774,0,0,0,.793-1.378V232.7a1.774,1.774,0,0,0-.793-1.384L261.045,188.79a1.774,1.774,0,0,0-1.591,0l-1.4.8a1.774,1.774,0,0,0-.8,1.378v56.779a1.774,1.774,0,0,0,.793,1.378l73.635,42.531a1.774,1.774,0,0,0,1.591,0Z",
    transform: "translate(-257.26 -188.602)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    "data-name": "Path 2147",
    d: "M333.279,291.661l1.4-.8a1.774,1.774,0,0,0,.793-1.378V232.7a1.774,1.774,0,0,0-.793-1.384L261.045,188.79a1.774,1.774,0,0,0-1.591,0l-1.4.8a1.774,1.774,0,0,0-.8,1.378v56.779a1.774,1.774,0,0,0,.793,1.378l73.635,42.531a1.774,1.774,0,0,0,1.591,0Z",
    transform: "translate(-257.26 -188.602)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    "data-name": "Path 2148",
    d: "M331.688,234.274l-73.629-42.519c-.438-.254-.8-.047-.8.461V249a1.774,1.774,0,0,0,.793,1.378L331.688,292.9c.438.254.793.047.793-.455V235.67a1.774,1.774,0,0,0-.792-1.4Z",
    transform: "translate(-257.26 -189.845)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    "data-name": "Path 2149",
    d: "M331.688,234.274l-73.629-42.519c-.438-.254-.8-.047-.8.461V249a1.774,1.774,0,0,0,.793,1.378L331.688,292.9c.438.254.793.047.793-.455V235.67a1.774,1.774,0,0,0-.792-1.4Z",
    transform: "translate(-257.26 -189.845)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    "data-name": "Path 2150",
    d: "M331.688,234.274l-73.629-42.519c-.438-.254-.8-.047-.8.461V249a1.774,1.774,0,0,0,.793,1.378L331.688,292.9c.438.254.793.047.793-.455V235.67a1.774,1.774,0,0,0-.792-1.4Z",
    transform: "translate(-257.26 -189.845)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2151",
    "data-name": "Path 2151",
    d: "M258.61,191.83c6.045,3.708,12.131,7.328,18.234,10.936l18.335,10.717,18.459,10.54,9.268,5.2,9.315,5.122-9.1-5.506-9.138-5.429L295.652,212.7l-18.477-10.54C271.019,198.679,264.838,195.213,258.61,191.83Z",
    transform: "translate(-257.812 -189.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    "data-name": "Path 2152",
    d: "M383.706,263.531l2.957-1.721a1.531,1.531,0,0,1,.237.781V319.37a1.774,1.774,0,0,1-.787,1.384l-1.4.8a1.774,1.774,0,0,1-1.437.071c.367.118.639-.095.639-.538V264.312a1.538,1.538,0,0,0-.213-.781Z",
    transform: "translate(-308.746 -218.511)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2153",
    "data-name": "Path 2153",
    d: "M384.44,275.821l2.987-1.721v14.845l-2.987,1.7Z",
    transform: "translate(-309.22 -223.532)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2154",
    "data-name": "Path 2154",
    d: "M384.44,275.821l2.987-1.721v14.845l-2.987,1.7Z",
    transform: "translate(-309.22 -223.532)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2155",
    "data-name": "Path 2155",
    d: "M257.26,203.56,332.48,247v14.828l-75.22-43.442Z",
    transform: "translate(-257.26 -194.713)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cards--inject-1",
    transform: "translate(3.839 30.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    "data-name": "Path 2156",
    d: "M367.974,326.4V336.1c0,.727-.509,1.023-1.141.662l-10.191-5.808a2.52,2.52,0,0,1-1.142-1.975v-9.706c0-.727.515-1.023,1.142-.656,2.78,1.6,7.411,4.2,10.191,5.8A2.519,2.519,0,0,1,367.974,326.4Z",
    transform: "translate(-301.235 -272.507)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(54.265 45.957)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    d: "M368.414,331.447l.26-.449L351.93,321.41l-.26.444Z",
    transform: "translate(-353.935 -319.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 0.515,
    height: 4.945,
    transform: "translate(7.943 7.852)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 0.515,
    height: 4.939,
    transform: "translate(4.016 5.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    d: "M368.414,339.827l.26-.45L351.93,329.79l-.26.444Z",
    transform: "translate(-353.935 -323.091)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    d: "M309.31,245.545a5.559,5.559,0,0,1-.621-2.662,2.4,2.4,0,0,1,.591-1.946c.39-.3.988-.219,1.774.219a5.12,5.12,0,0,1,.863.627,4.011,4.011,0,0,1,.657.739.3.3,0,0,1,.065.177.219.219,0,0,1-.036.124l-.231.4c-.03.041-.059.059-.095.041a.592.592,0,0,1-.106-.118,3.4,3.4,0,0,0-.988-.881q-.674-.39-1.047-.089a1.715,1.715,0,0,0-.373,1.325,3.738,3.738,0,0,0,.39,1.774,2.7,2.7,0,0,0,1.059,1.124,1.626,1.626,0,0,0,1.035.284.219.219,0,0,1,.112,0,.313.313,0,0,1,.089.148l.254.733a.422.422,0,0,1,0,.118c0,.035,0,.065-.083.089a2.023,2.023,0,0,1-1.573-.426A4.59,4.59,0,0,1,309.31,245.545Z",
    transform: "translate(-282.11 -240.761)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    d: "M316.471,249.75a.68.68,0,0,1-.071-.325v-5.163q0-.2.071-.248c.041-.041.118-.03.225.035l1.65.952a3.129,3.129,0,0,1,1.662,2.892,1.828,1.828,0,0,1-.2.94.651.651,0,0,1-.591.319l.686,2.4a.594.594,0,0,1,0,.13c0,.106-.047.136-.136.083l-.727-.42a.444.444,0,0,1-.136-.112.413.413,0,0,1-.077-.177l-.591-2.265-.781-.45v1.709c0,.124,0,.207-.065.243s-.118,0-.225-.041l-.491-.278a.544.544,0,0,1-.207-.225Zm1.721-2.035c.248.142.432.183.556.112s.189-.248.189-.55a1.568,1.568,0,0,0-.172-.763,1.3,1.3,0,0,0-.509-.5l-.781-.449v1.745Z",
    transform: "translate(-285.26 -242.08)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    d: "M323.473,253.8a.757.757,0,0,1-.065-.325v-5.169a.355.355,0,0,1,.065-.248c.047-.035.124,0,.225.035l2.715,1.567a.532.532,0,0,1,.219.207.769.769,0,0,1,.053.313v.325a.39.39,0,0,1-.053.254c-.041.035-.112,0-.219-.035l-1.928-1.118v1.366l1.349.781a.515.515,0,0,1,.213.207.674.674,0,0,1,.059.313v.308c0,.13,0,.219-.059.254s-.112,0-.213-.041l-1.349-.775v1.384l1.922,1.112a.462.462,0,0,1,.213.213.687.687,0,0,1,.059.319v.313c0,.136,0,.219-.059.248s-.106,0-.213-.041L323.7,254.01A.591.591,0,0,1,323.473,253.8Z",
    transform: "translate(-288.123 -243.737)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    d: "M329.819,257.463a.68.68,0,0,1-.071-.325v-5.169a.325.325,0,0,1,.071-.248c.041-.035.118,0,.225.035l1.372.793a4.412,4.412,0,0,1,1.7,1.7,5.235,5.235,0,0,1,.591,2.585q0,1.514-.591,1.9c-.39.254-.958.172-1.692-.254l-1.372-.793a.5.5,0,0,1-.231-.219Zm1.65,0q.591.337.869.071a1.963,1.963,0,0,0,.284-1.313,3.862,3.862,0,0,0-.284-1.638,2.159,2.159,0,0,0-.869-.929l-.645-.367V257.1Z",
    transform: "translate(-290.712 -245.232)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    d: "M337.4,261.837a.656.656,0,0,1-.071-.319v-5.169a.325.325,0,0,1,.071-.248c.041-.035.118,0,.225.035l.491.284a.515.515,0,0,1,.225.225.663.663,0,0,1,.065.325v5.169c0,.13,0,.213-.065.248s-.118,0-.225-.041l-.491-.284a.515.515,0,0,1-.225-.225Z",
    transform: "translate(-293.809 -247.022)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    "data-name": "Path 2165",
    d: "M341.253,264.076a.681.681,0,0,1-.065-.325v-4.489l-1.076-.591a.592.592,0,0,1-.213-.207.7.7,0,0,1-.059-.319v-.325c0-.13,0-.213.059-.248s.112,0,.213.035l3.229,1.863a.508.508,0,0,1,.219.213.722.722,0,0,1,.065.325v.319c0,.13,0,.213-.065.242s-.112,0-.219-.035l-1.041-.645v4.489c0,.13,0,.207-.071.242s-.118,0-.231-.041l-.485-.278A.592.592,0,0,1,341.253,264.076Z",
    transform: "translate(-294.836 -247.622)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    d: "M351.306,269.79a5.454,5.454,0,0,1-.627-2.656c0-1.005.2-1.656.591-1.946s.994-.225,1.774.213a4.978,4.978,0,0,1,.864.627,4.208,4.208,0,0,1,.656.739.272.272,0,0,1,.065.177.207.207,0,0,1-.035.13l-.231.4c0,.047-.059.059-.089.041a.391.391,0,0,1-.112-.112,3.269,3.269,0,0,0-.988-.887c-.45-.254-.8-.284-1.047-.083a1.71,1.71,0,0,0-.373,1.325,3.708,3.708,0,0,0,.39,1.774,2.733,2.733,0,0,0,1.065,1.13,1.6,1.6,0,0,0,1.029.284.166.166,0,0,1,.112,0,.284.284,0,0,1,.089.148l.26.727a.4.4,0,0,1,0,.124c0,.035,0,.059-.077.083a2.02,2.02,0,0,1-1.579-.42A4.513,4.513,0,0,1,351.306,269.79Z",
    transform: "translate(-299.265 -250.669)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    d: "M357.905,274.3a.453.453,0,0,1,0-.124l1.692-4.4a.254.254,0,0,1,.1-.148.189.189,0,0,1,.166.035l.473.278a.419.419,0,0,1,.16.142,1.03,1.03,0,0,1,.095.266l1.7,6.352a.815.815,0,0,1,0,.148c0,.1-.041.13-.118.083l-.793-.455a.367.367,0,0,1-.13-.118.652.652,0,0,1-.077-.189l-.3-1.183-1.585-.917-.3.858a.1.1,0,0,1-.077.1.206.206,0,0,1-.136-.035l-.787-.455A.231.231,0,0,1,357.905,274.3Zm2.75-.473-.544-2.2-.544,1.567Z",
    transform: "translate(-302.215 -252.551)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    d: "M366.363,278.563a.68.68,0,0,1-.065-.325v-5.169a.331.331,0,0,1,.065-.248c.047-.035.124,0,.225.036l1.656.958a3.129,3.129,0,0,1,1.662,2.892,1.738,1.738,0,0,1-.2.934.651.651,0,0,1-.591.325l.686,2.4a.525.525,0,0,1,0,.13c0,.106-.041.13-.136.077l-.722-.42a.469.469,0,0,1-.142-.106.592.592,0,0,1-.077-.183l-.591-2.259-.775-.449v1.68a.337.337,0,0,1-.065.248c-.047.035-.118,0-.231-.041l-.491-.284A.591.591,0,0,1,366.363,278.563Zm1.721-2.035c.248.142.438.177.562.112s.183-.254.183-.556a1.543,1.543,0,0,0-.166-.757,1.372,1.372,0,0,0-.515-.509l-.775-.444v1.739Z",
    transform: "translate(-305.645 -253.853)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    "data-name": "Path 2169",
    d: "M373.371,282.607a.669.669,0,0,1-.071-.319v-5.169q0-.2.071-.248c.047-.035.118,0,.225.036l1.372.793a4.359,4.359,0,0,1,1.7,1.692,5.252,5.252,0,0,1,.591,2.585c0,1.011-.2,1.644-.591,1.9s-.958.172-1.692-.254l-1.378-.769a.55.55,0,0,1-.225-.248Zm1.65,0q.591.337.869.071c.189-.172.284-.591.284-1.307a3.844,3.844,0,0,0-.284-1.638,2.129,2.129,0,0,0-.869-.929l-.639-.373v3.809Z",
    transform: "translate(-308.507 -255.507)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(26.579)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    d: "M309.31,245.545a5.559,5.559,0,0,1-.621-2.662,2.4,2.4,0,0,1,.591-1.946c.39-.3.988-.219,1.774.219a5.12,5.12,0,0,1,.863.627,4.011,4.011,0,0,1,.657.739.3.3,0,0,1,.065.177.219.219,0,0,1-.036.124l-.231.4c-.03.041-.059.059-.095.041a.592.592,0,0,1-.106-.118,3.4,3.4,0,0,0-.988-.881q-.674-.39-1.047-.089a1.715,1.715,0,0,0-.373,1.325,3.738,3.738,0,0,0,.39,1.774,2.7,2.7,0,0,0,1.059,1.124,1.626,1.626,0,0,0,1.035.284.219.219,0,0,1,.112,0,.313.313,0,0,1,.089.148l.254.733a.422.422,0,0,1,0,.118c0,.035,0,.065-.083.089a2.023,2.023,0,0,1-1.573-.426A4.59,4.59,0,0,1,309.31,245.545Z",
    transform: "translate(-308.688 -240.761)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    d: "M316.471,249.75a.68.68,0,0,1-.071-.325v-5.163q0-.2.071-.248c.041-.041.118-.03.225.035l1.65.952a3.129,3.129,0,0,1,1.662,2.892,1.828,1.828,0,0,1-.2.94.651.651,0,0,1-.591.319l.686,2.4a.594.594,0,0,1,0,.13c0,.106-.047.136-.136.083l-.727-.42a.444.444,0,0,1-.136-.112.413.413,0,0,1-.077-.177l-.591-2.265-.781-.45v1.709c0,.124,0,.207-.065.243s-.118,0-.225-.041l-.491-.278a.544.544,0,0,1-.207-.225Zm1.721-2.035c.248.142.432.183.556.112s.189-.248.189-.55a1.568,1.568,0,0,0-.172-.763,1.3,1.3,0,0,0-.509-.5l-.781-.449v1.745Z",
    transform: "translate(-311.839 -242.08)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    d: "M323.473,253.8a.757.757,0,0,1-.065-.325v-5.169a.355.355,0,0,1,.065-.248c.047-.035.124,0,.225.035l2.715,1.567a.532.532,0,0,1,.219.207.769.769,0,0,1,.053.313v.325a.39.39,0,0,1-.053.254c-.041.035-.112,0-.219-.035l-1.928-1.118v1.366l1.349.781a.515.515,0,0,1,.213.207.674.674,0,0,1,.059.313v.308c0,.13,0,.219-.059.254s-.112,0-.213-.041l-1.349-.775v1.384l1.922,1.112a.462.462,0,0,1,.213.213.687.687,0,0,1,.059.319v.313c0,.136,0,.219-.059.248s-.106,0-.213-.041L323.7,254.01A.591.591,0,0,1,323.473,253.8Z",
    transform: "translate(-314.701 -243.737)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2173",
    "data-name": "Path 2173",
    d: "M329.819,257.463a.68.68,0,0,1-.071-.325v-5.169a.325.325,0,0,1,.071-.248c.041-.035.118,0,.225.035l1.372.793a4.412,4.412,0,0,1,1.7,1.7,5.235,5.235,0,0,1,.591,2.585q0,1.514-.591,1.9c-.39.254-.958.172-1.692-.254l-1.372-.793a.5.5,0,0,1-.231-.219Zm1.65,0q.591.337.869.071a1.963,1.963,0,0,0,.284-1.313,3.862,3.862,0,0,0-.284-1.638,2.159,2.159,0,0,0-.869-.929l-.645-.367V257.1Z",
    transform: "translate(-317.291 -245.232)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2174",
    "data-name": "Path 2174",
    d: "M337.4,261.837a.656.656,0,0,1-.071-.319v-5.169a.325.325,0,0,1,.071-.248c.041-.035.118,0,.225.035l.491.284a.515.515,0,0,1,.225.225.663.663,0,0,1,.065.325v5.169c0,.13,0,.213-.065.248s-.118,0-.225-.041l-.491-.284a.515.515,0,0,1-.225-.225Z",
    transform: "translate(-320.388 -247.022)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2175",
    "data-name": "Path 2175",
    d: "M341.253,264.076a.681.681,0,0,1-.065-.325v-4.489l-1.076-.591a.592.592,0,0,1-.213-.207.7.7,0,0,1-.059-.319v-.325c0-.13,0-.213.059-.248s.112,0,.213.035l3.229,1.863a.508.508,0,0,1,.219.213.722.722,0,0,1,.065.325v.319c0,.13,0,.213-.065.242s-.112,0-.219-.035l-1.041-.645v4.489c0,.13,0,.207-.071.242s-.118,0-.231-.041l-.485-.278A.592.592,0,0,1,341.253,264.076Z",
    transform: "translate(-321.415 -247.622)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2176",
    "data-name": "Path 2176",
    d: "M351.306,269.79a5.454,5.454,0,0,1-.627-2.656c0-1.005.2-1.656.591-1.946s.994-.225,1.774.213a4.978,4.978,0,0,1,.864.627,4.208,4.208,0,0,1,.656.739.272.272,0,0,1,.065.177.207.207,0,0,1-.035.13l-.231.4c0,.047-.059.059-.089.041a.391.391,0,0,1-.112-.112,3.269,3.269,0,0,0-.988-.887c-.45-.254-.8-.284-1.047-.083a1.71,1.71,0,0,0-.373,1.325,3.708,3.708,0,0,0,.39,1.774,2.733,2.733,0,0,0,1.065,1.13,1.6,1.6,0,0,0,1.029.284.166.166,0,0,1,.112,0,.284.284,0,0,1,.089.148l.26.727a.4.4,0,0,1,0,.124c0,.035,0,.059-.077.083a2.02,2.02,0,0,1-1.579-.42A4.513,4.513,0,0,1,351.306,269.79Z",
    transform: "translate(-325.843 -250.669)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2177",
    "data-name": "Path 2177",
    d: "M357.905,274.3a.453.453,0,0,1,0-.124l1.692-4.4a.254.254,0,0,1,.1-.148.189.189,0,0,1,.166.035l.473.278a.419.419,0,0,1,.16.142,1.03,1.03,0,0,1,.095.266l1.7,6.352a.815.815,0,0,1,0,.148c0,.1-.041.13-.118.083l-.793-.455a.367.367,0,0,1-.13-.118.652.652,0,0,1-.077-.189l-.3-1.183-1.585-.917-.3.858a.1.1,0,0,1-.077.1.206.206,0,0,1-.136-.035l-.787-.455A.231.231,0,0,1,357.905,274.3Zm2.75-.473-.544-2.2-.544,1.567Z",
    transform: "translate(-328.793 -252.551)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2178",
    "data-name": "Path 2178",
    d: "M366.363,278.563a.68.68,0,0,1-.065-.325v-5.169a.331.331,0,0,1,.065-.248c.047-.035.124,0,.225.036l1.656.958a3.129,3.129,0,0,1,1.662,2.892,1.738,1.738,0,0,1-.2.934.651.651,0,0,1-.591.325l.686,2.4a.525.525,0,0,1,0,.13c0,.106-.041.13-.136.077l-.722-.42a.469.469,0,0,1-.142-.106.592.592,0,0,1-.077-.183l-.591-2.259-.775-.449v1.68a.337.337,0,0,1-.065.248c-.047.035-.118,0-.231-.041l-.491-.284A.591.591,0,0,1,366.363,278.563Zm1.721-2.035c.248.142.438.177.562.112s.183-.254.183-.556a1.543,1.543,0,0,0-.166-.757,1.372,1.372,0,0,0-.515-.509l-.775-.444v1.739Z",
    transform: "translate(-332.223 -253.853)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    d: "M373.371,282.607a.669.669,0,0,1-.071-.319v-5.169q0-.2.071-.248c.047-.035.118,0,.225.036l1.372.793a4.359,4.359,0,0,1,1.7,1.692,5.252,5.252,0,0,1,.591,2.585c0,1.011-.2,1.644-.591,1.9s-.958.172-1.692-.254l-1.378-.769a.55.55,0,0,1-.225-.248Zm1.65,0q.591.337.869.071c.189-.172.284-.591.284-1.307a3.844,3.844,0,0,0-.284-1.638,2.129,2.129,0,0,0-.869-.929l-.639-.373v3.809Z",
    transform: "translate(-335.085 -255.507)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    d: "M275.306,269.125l2.9,1.68a1.5,1.5,0,0,1,.686,1.183v.887c0,.438-.308.591-.686.4l-2.9-1.68a1.508,1.508,0,0,1-.686-1.183v-.887C274.62,269.084,274.928,268.906,275.306,269.125Z",
    transform: "translate(-268.191 -252.311)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2181",
    "data-name": "Path 2181",
    d: "M264.466,262.865l2.9,1.68a1.508,1.508,0,0,1,.686,1.183v.887c0,.438-.308.591-.686.4l-2.9-1.68a1.508,1.508,0,0,1-.686-1.183v-.887C263.78,262.824,264.088,262.646,264.466,262.865Z",
    transform: "translate(-263.762 -249.754)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    d: "M301.212,294.647l-36.2-20.9c-.627-.367-1.136-.071-1.136.657v1.071a2.526,2.526,0,0,0,1.136,1.975l36.2,20.89c.633.367,1.141.071,1.141-.656v-1.071a2.5,2.5,0,0,0-1.141-1.97Z",
    transform: "translate(-263.803 -254.175)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    d: "M275.306,269.125l2.9,1.68a1.5,1.5,0,0,1,.686,1.183v.887c0,.438-.308.591-.686.4l-2.9-1.68a1.508,1.508,0,0,1-.686-1.183v-.887C274.62,269.084,274.928,268.906,275.306,269.125Z",
    transform: "translate(-268.191 -252.311)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    d: "M264.466,262.865l2.9,1.68a1.508,1.508,0,0,1,.686,1.183v.887c0,.438-.308.591-.686.4l-2.9-1.68a1.508,1.508,0,0,1-.686-1.183v-.887C263.78,262.824,264.088,262.646,264.466,262.865Z",
    transform: "translate(-263.762 -249.754)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M301.212,294.647l-36.2-20.9c-.627-.367-1.136-.071-1.136.657v1.071a2.526,2.526,0,0,0,1.136,1.975l36.2,20.89c.633.367,1.141.071,1.141-.656v-1.071a2.5,2.5,0,0,0-1.141-1.97Z",
    transform: "translate(-263.803 -254.175)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    d: "M264.489,245.829l.136.077a1.775,1.775,0,0,1,.739,1.42v2.851c0,.544-.331.8-.751.591l-.112-.059a1.715,1.715,0,0,1-.751-1.4V246.4C263.768,245.847,264.1,245.592,264.489,245.829Z",
    transform: "translate(-263.75 -242.796)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    d: "M270.985,249.588l.13.077a1.774,1.774,0,0,1,.745,1.414v2.857c0,.55-.337.81-.751.591l-.118-.065a1.709,1.709,0,0,1-.751-1.4V250.15C270.24,249.6,270.571,249.352,270.985,249.588Z",
    transform: "translate(-266.402 -244.331)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    d: "M277.488,253.339l.136.077a1.775,1.775,0,0,1,.739,1.419v2.851c0,.544-.337.8-.751.591l-.112-.059a1.7,1.7,0,0,1-.751-1.4v-2.91C276.725,253.357,277.057,253.1,277.488,253.339Z",
    transform: "translate(-269.06 -245.864)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    d: "M283.909,257.1l.136.077a1.774,1.774,0,0,1,.739,1.414v2.851c0,.55-.337.81-.751.591l-.112-.065a1.715,1.715,0,0,1-.751-1.4v-2.916C283.17,257.11,283.5,256.862,283.909,257.1Z",
    transform: "translate(-271.684 -247.399)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    d: "M294.749,263.279l.136.077a1.774,1.774,0,0,1,.739,1.419v2.851c0,.544-.337.8-.751.591l-.112-.059a1.715,1.715,0,0,1-.751-1.4v-2.91C294,263.3,294.341,263.042,294.749,263.279Z",
    transform: "translate(-276.113 -249.925)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    d: "M301.205,267.038l.136.077a1.775,1.775,0,0,1,.739,1.414v2.851c0,.544-.337.8-.751.591l-.118-.059a1.715,1.715,0,0,1-.751-1.4V267.57C300.466,267.05,300.779,266.8,301.205,267.038Z",
    transform: "translate(-278.748 -251.46)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    d: "M307.675,270.789l.13.077a1.774,1.774,0,0,1,.745,1.419v2.851c0,.544-.337.8-.751.591l-.118-.065a1.709,1.709,0,0,1-.751-1.39v-2.922C306.93,270.807,307.261,270.552,307.675,270.789Z",
    transform: "translate(-281.391 -252.993)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    d: "M314.139,274.549l.136.077a1.774,1.774,0,0,1,.739,1.414v2.88c0,.544-.337.8-.751.591l-.112-.059a1.715,1.715,0,0,1-.751-1.4v-2.91C313.4,274.56,313.755,274.312,314.139,274.549Z",
    transform: "translate(-284.035 -254.529)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    d: "M324.979,280.728l.136.077a1.774,1.774,0,0,1,.739,1.419v2.851c0,.544-.337.8-.751.591l-.112-.065a1.709,1.709,0,0,1-.751-1.39V281.3C324.24,280.74,324.571,280.492,324.979,280.728Z",
    transform: "translate(-288.463 -257.053)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2195",
    "data-name": "Path 2195",
    d: "M331.488,284.488l.136.077a1.774,1.774,0,0,1,.739,1.414v2.851c0,.544-.331.8-.751.591l-.112-.059a1.715,1.715,0,0,1-.751-1.4v-2.91C330.719,284.5,331.05,284.252,331.488,284.488Z",
    transform: "translate(-291.122 -258.589)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2196",
    "data-name": "Path 2196",
    d: "M337.905,288.238l.13.077a1.774,1.774,0,0,1,.745,1.419v2.845c0,.55-.337.81-.751.591l-.118-.065a1.709,1.709,0,0,1-.751-1.4v-2.9C337.16,288.25,337.491,288,337.905,288.238Z",
    transform: "translate(-293.742 -260.121)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2197",
    "data-name": "Path 2197",
    d: "M344.369,291.989l.136.083a1.774,1.774,0,0,1,.739,1.414v2.851c0,.544-.337.8-.751.591l-.112-.059a1.7,1.7,0,0,1-.751-1.4v-2.922C343.624,292.007,343.961,291.752,344.369,291.989Z",
    transform: "translate(-296.385 -261.654)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    d: "M355.209,298.178l.136.077a1.774,1.774,0,0,1,.739,1.419v2.845c0,.55-.337.81-.751.591l-.112-.065a1.692,1.692,0,0,1-.751-1.4v-2.9C354.47,298.19,354.783,297.942,355.209,298.178Z",
    transform: "translate(-300.814 -264.182)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    d: "M361.669,301.935l.136.083a1.774,1.774,0,0,1,.739,1.414v2.851c0,.544-.337.8-.751.591l-.112-.059a1.715,1.715,0,0,1-.751-1.4v-2.91C360.93,301.935,361.261,301.693,361.669,301.935Z",
    transform: "translate(-303.453 -265.716)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2200",
    "data-name": "Path 2200",
    d: "M368.129,305.688l.136.077a1.775,1.775,0,0,1,.739,1.414v2.851c0,.55-.331.81-.751.591l-.112-.065a1.709,1.709,0,0,1-.751-1.4v-2.91C367.39,305.7,367.751,305.452,368.129,305.688Z",
    transform: "translate(-306.092 -267.251)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    d: "M374.6,309.439l.13.077a1.774,1.774,0,0,1,.745,1.419v2.851c0,.544-.337.8-.751.591l-.118-.059a1.715,1.715,0,0,1-.751-1.4v-2.91C373.85,309.457,374.181,309.2,374.6,309.439Z",
    transform: "translate(-308.731 -268.783)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    d: "M340.985,310.765c0,1.626-1.153,2.289-2.561,1.479l-69.353-40.023a5.678,5.678,0,0,1-2.561-4.436V229.11l74.475,43Z",
    transform: "translate(-245.348 -188.869)",
    fill: "#fff",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    d: "M233.386,263.045l58,60.736c.591.633,1.183.822,1.526.591s.515-.668.515-1.419V251.234a7.577,7.577,0,0,0-.591-2.626,7.688,7.688,0,0,0-1.479-2.466L233.386,185.37A9.262,9.262,0,0,1,230.73,179v77.669a9.262,9.262,0,0,0,2.656,6.376Z",
    transform: "translate(-230.73 -168.397)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    "data-name": "Path 2204",
    d: "M237.526,203.519a.3.3,0,0,1-.3-.3v-.887a.3.3,0,0,1,.189-.272.29.29,0,0,1,.319.065l.591.645a.3.3,0,0,1,0,.42.29.29,0,0,1-.414,0l-.106-.106v.112a.3.3,0,0,1-.284.319Z",
    transform: "translate(-233.386 -177.811)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    d: "M293.762,323.394a.3.3,0,0,1-.3-.3v-1.745a.3.3,0,1,1,.591,0V323.1A.3.3,0,0,1,293.762,323.394Zm0-4.655a.3.3,0,0,1-.3-.3v-1.733a.3.3,0,0,1,.591,0v1.745a.3.3,0,0,1-.3.3Zm0-4.655a.3.3,0,0,1-.3-.3v-1.745a.3.3,0,0,1,.591,0v1.745a.3.3,0,0,1-.3.308Zm0-4.655a.3.3,0,0,1-.3-.3V307.36a.3.3,0,0,1,.591,0v1.774a.3.3,0,0,1-.3.308Zm0-4.655a.3.3,0,0,1-.3-.3v-1.774a.3.3,0,0,1,.591,0v1.774a.3.3,0,0,1-.3.308Zm0-4.655a.3.3,0,0,1-.3-.3V298.08a.3.3,0,0,1,.3-.3.3.3,0,0,1,.3.3v1.745a.3.3,0,0,1-.3.308Zm0-4.655a.3.3,0,0,1-.3-.3v-1.745a.3.3,0,0,1,.3-.3.3.3,0,0,1,.3.3v1.745a.3.3,0,0,1-.3.308Zm0-4.649a.3.3,0,0,1-.3-.3v-1.774a.3.3,0,0,1,.3-.3.3.3,0,0,1,.3.3v1.774a.3.3,0,0,1-.3.308Zm0-4.655a.3.3,0,0,1-.3-.3v-1.745a.3.3,0,1,1,.591,0v1.745a.3.3,0,0,1-.3.308Zm0-4.655a.3.3,0,0,1-.3-.3v-1.745a.3.3,0,1,1,.591,0v1.745a.3.3,0,0,1-.3.308Zm0-4.655a.3.3,0,0,1-.3-.3v-1.745a.3.3,0,0,1,.591,0v1.745a.3.3,0,0,1-.3.308Zm0-4.655a.3.3,0,0,1-.3-.3v-1.739a.3.3,0,1,1,.591,0v1.774a.3.3,0,0,1-.3.272Zm0-4.655a.3.3,0,0,1-.3-.3V265.5a.3.3,0,1,1,.591,0v1.745a.3.3,0,0,1-.3.308Zm0-4.678a.278.278,0,0,1-.3-.272,3.306,3.306,0,0,0-.26-1.071c-.071-.172-.136-.325-.2-.455a.295.295,0,1,1,.526-.266c.071.148.148.313.225.509a3.9,3.9,0,0,1,.3,1.23.319.319,0,0,1-.3.337Zm-2.366-3.827a.308.308,0,0,1-.213-.095L290,257.684a.3.3,0,0,1,.432-.408l1.183,1.26a.3.3,0,0,1,0,.42.307.307,0,0,1-.242.095Zm-3.212-3.371a.3.3,0,0,1-.213-.089l-1.183-1.266a.3.3,0,0,1,.426-.408l1.183,1.266a.3.3,0,0,1-.213.5Zm-3.212-3.365a.29.29,0,0,1-.213-.089l-1.183-1.266a.3.3,0,0,1,0-.42.29.29,0,0,1,.414,0l1.183,1.266a.3.3,0,0,1-.213.5Zm-3.217-3.365a.284.284,0,0,1-.254-.065l-1.183-1.26a.3.3,0,1,1,.42-.42l1.183,1.26a.3.3,0,0,1,0,.42.308.308,0,0,1-.189.077Zm-3.212-3.354a.307.307,0,0,1-.213-.095l-1.183-1.26a.3.3,0,0,1,.432-.408l1.183,1.26a.3.3,0,0,1,0,.42.308.308,0,0,1-.219.083Zm-3.212-3.371a.3.3,0,0,1-.213-.089l-1.183-1.266a.3.3,0,0,1,.426-.408l1.183,1.266a.29.29,0,0,1,0,.414.266.266,0,0,1-.237.083Zm-3.212-3.365a.284.284,0,0,1-.213-.089l-1.183-1.266a.3.3,0,1,1,.426-.408l1.183,1.266a.29.29,0,0,1,0,.414.3.3,0,0,1-.237.083Zm-3.217-3.365a.284.284,0,0,1-.213-.095l-1.183-1.26a.3.3,0,1,1,.432-.408l1.183,1.26a.3.3,0,0,1,0,.42.307.307,0,0,1-.242.083Zm-3.212-3.371a.3.3,0,0,1-.213-.089l-1.183-1.26a.3.3,0,0,1,0-.42.29.29,0,0,1,.414,0l1.183,1.26a.3.3,0,0,1,0,.42.314.314,0,0,1-.225.089Zm-3.235-3.348a.29.29,0,0,1-.213-.089l-1.183-1.266a.29.29,0,0,1,0-.414.3.3,0,0,1,.42,0l1.183,1.266a.29.29,0,0,1,0,.414A.266.266,0,0,1,262.457,228.762Zm-3.217-3.365a.3.3,0,0,1-.213-.089l-1.183-1.278a.3.3,0,1,1,.42-.42l1.183,1.266a.29.29,0,0,1,0,.414.307.307,0,0,1-.207.089Zm-3.212-3.365a.284.284,0,0,1-.213-.095l-1.183-1.26a.3.3,0,0,1,.432-.408l1.183,1.26a.3.3,0,0,1,0,.42.308.308,0,0,1-.219.065Zm-3.212-3.365a.308.308,0,0,1-.213-.095l-1.183-1.26a.3.3,0,0,1,.426-.414l1.183,1.266a.3.3,0,0,1,0,.42.29.29,0,0,1-.213.065Zm-3.212-3.371a.3.3,0,0,1-.219-.089L248.2,213.94a.29.29,0,0,1,0-.414.3.3,0,0,1,.42,0l1.183,1.266a.29.29,0,0,1,0,.414.278.278,0,0,1-.2.071Zm-3.218-3.365a.284.284,0,0,1-.213-.095l-1.183-1.26a.3.3,0,0,1,.432-.408l1.183,1.26a.3.3,0,0,1,0,.42.307.307,0,0,1-.219.065Zm-3.212-3.365a.284.284,0,0,1-.213-.095l-1.183-1.26a.3.3,0,0,1,0-.42.29.29,0,0,1,.414,0l1.183,1.26a.3.3,0,0,1,0,.42.29.29,0,0,1-.2.077Z",
    transform: "translate(-235.209 -179.715)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    d: "M329.118,409.419a.3.3,0,0,1-.213-.089l-.591-.645a.3.3,0,0,1,.432-.408l.1.106v-.148a.3.3,0,1,1,.591,0v.887a.284.284,0,0,1-.183.272A.255.255,0,0,1,329.118,409.419Z",
    transform: "translate(-270.565 -261.931)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    d: "M289.254,325.183a.284.284,0,0,1-.213-.089l-1.248-1.307a.3.3,0,0,1,0-.42.3.3,0,0,1,.42,0l1.248,1.307a.29.29,0,0,1,0,.414A.3.3,0,0,1,289.254,325.183Zm-3.324-3.478a.284.284,0,0,1-.213-.095l-1.248-1.3a.3.3,0,0,1,.432-.408l1.242,1.3a.3.3,0,0,1,0,.42.319.319,0,0,1-.213.083Zm-3.294-3.478a.284.284,0,0,1-.213-.095l-1.242-1.3a.3.3,0,1,1,.42-.42l1.242,1.3a.3.3,0,0,1,0,.42.307.307,0,0,1-.207.095Zm-3.348-3.5a.3.3,0,0,1-.213-.095l-1.248-1.307a.3.3,0,0,1,.426-.408l1.248,1.307a.3.3,0,0,1,0,.42A.3.3,0,0,1,279.288,314.726Zm-3.324-3.484a.3.3,0,0,1-.213-.089l-1.248-1.307a.29.29,0,0,1,0-.414.3.3,0,0,1,.42,0l1.242,1.307a.3.3,0,0,1,0,.42.314.314,0,0,1-.2.106Zm-3.324-3.478a.3.3,0,0,1-.213-.089l-1.242-1.307a.3.3,0,1,1,.426-.408l1.248,1.307a.29.29,0,0,1,0,.414.278.278,0,0,1-.219.106Zm-3.318-3.478a.29.29,0,0,1-.213-.089l-1.26-1.3a.3.3,0,0,1,0-.42.29.29,0,0,1,.414,0l1.248,1.3a.3.3,0,0,1,0,.42.29.29,0,0,1-.189.112ZM266,300.809a.284.284,0,0,1-.213-.095l-1.248-1.3a.3.3,0,0,1,.432-.408l1.242,1.3a.3.3,0,0,1,0,.42.308.308,0,0,1-.213.107Zm-3.324-3.478a.284.284,0,0,1-.213-.095l-1.242-1.3a.3.3,0,1,1,.426-.408l1.248,1.3a.3.3,0,0,1,0,.42.307.307,0,0,1-.219.106Zm-3.318-3.478a.307.307,0,0,1-.213-.095l-1.248-1.307a.3.3,0,0,1,.426-.408l1.248,1.331a.3.3,0,0,1,0,.42.29.29,0,0,1-.213.083Zm-3.336-3.46a.3.3,0,0,1-.213-.089L254.559,289a.29.29,0,0,1,0-.414.3.3,0,0,1,.42,0l1.242,1.307a.29.29,0,0,1-.213.5Zm-3.306-3.466a.3.3,0,0,1-.219-.089l-1.242-1.307a.3.3,0,1,1,.426-.408l1.248,1.307a.29.29,0,0,1,0,.414.278.278,0,0,1-.213.083Zm-3.324-3.478a.3.3,0,0,1-.213-.089l-1.248-1.307a.3.3,0,0,1,0-.42.29.29,0,0,1,.414,0l1.248,1.3a.3.3,0,0,1,0,.42.29.29,0,0,1-.2.083Zm-3.324-3.478a.284.284,0,0,1-.213-.095l-1.248-1.3a.3.3,0,1,1,.432-.408l1.242,1.3a.3.3,0,0,1,0,.42.308.308,0,0,1-.213.071Zm-3.318-3.478a.29.29,0,0,1-.219-.095l-1.242-1.3a.3.3,0,1,1,.426-.408l1.248,1.3a.3.3,0,0,1,0,.42.3.3,0,0,1-.213.071Zm-3.324-3.478a.307.307,0,0,1-.213-.095l-.39-.408a5.69,5.69,0,0,1-.793-1.029.284.284,0,0,1,.095-.4.29.29,0,0,1,.408.095,5.6,5.6,0,0,0,.722.929l.384.408a.3.3,0,0,1,0,.42.29.29,0,0,1-.213.071Zm-1.9-4.253a.3.3,0,0,1-.3-.3v-1.774a.3.3,0,0,1,.591,0v1.774a.3.3,0,0,1-.3.284Zm0-4.809a.3.3,0,0,1-.3-.3v-1.8a.3.3,0,1,1,.591,0v1.8a.3.3,0,0,1-.3.284Zm0-4.814a.3.3,0,0,1-.3-.3v-1.8a.3.3,0,0,1,.3-.3.3.3,0,0,1,.3.3v1.8a.3.3,0,0,1-.3.284Zm0-4.808a.3.3,0,0,1-.3-.3v-1.8a.3.3,0,0,1,.3-.3.3.3,0,0,1,.3.3v1.8a.3.3,0,0,1-.3.284Zm0-4.808a.3.3,0,0,1-.3-.3v-1.8a.3.3,0,1,1,.591,0v1.8a.3.3,0,0,1-.3.284Zm0-4.808a.3.3,0,0,1-.3-.3v-1.8a.3.3,0,1,1,.591,0v1.8a.3.3,0,0,1-.3.284Zm0-4.814a.3.3,0,0,1-.3-.3v-1.8a.3.3,0,0,1,.3-.3.3.3,0,0,1,.3.3v1.81a.3.3,0,0,1-.3.278Zm0-4.808a.3.3,0,0,1-.3-.3v-1.8a.3.3,0,0,1,.3-.3.3.3,0,0,1,.3.3v1.8a.3.3,0,0,1-.3.284Zm0-4.808a.3.3,0,0,1-.3-.3v-1.8a.3.3,0,0,1,.591,0v1.8a.3.3,0,0,1-.3.284Zm0-4.808a.3.3,0,0,1-.3-.3v-1.8a.3.3,0,0,1,.591,0v1.8a.3.3,0,0,1-.3.284Zm0-4.814a.3.3,0,0,1-.3-.3v-1.8a.3.3,0,0,1,.3-.3.3.3,0,0,1,.3.3v1.8a.3.3,0,0,1-.3.284Zm0-4.808a.3.3,0,0,1-.3-.3v-1.8a.3.3,0,0,1,.3-.3.3.3,0,0,1,.3.3v1.8a.3.3,0,0,1-.3.284Zm0-4.808a.3.3,0,0,1-.3-.3v-1.8a.3.3,0,1,1,.591,0v1.8a.3.3,0,0,1-.3.284Z",
    transform: "translate(-233.386 -180.51)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    d: "M339.8,292.76l-4.016,2.324a7.576,7.576,0,0,1,.591,2.626v71.731c0,.751-.2,1.23-.515,1.419l3.951-2.283c.325-.183.521-.668.521-1.419V295.427A7.316,7.316,0,0,0,339.8,292.76Z",
    transform: "translate(-273.648 -214.874)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    d: "M315.836,338.653a9.558,9.558,0,0,0-2.153-5.761c-1.183-1.242-2.153-.686-2.153,1.248a9.528,9.528,0,0,0,2.153,5.755C314.872,341.143,315.836,340.587,315.836,338.653Z",
    transform: "translate(-263.741 -230.999)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M411.87,298.95l9.966,5.755-9.966,5.755Z",
    transform: "translate(-304.735 -217.403)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M419.435,304.149l2.242-1.3a1.561,1.561,0,0,0,0-2.957l-9.806-5.666v2.821L418.713,301a.485.485,0,0,1,0,.834l-1.68.97Z",
    transform: "translate(-304.735 -215.474)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    d: "M397.282,313.522a10.987,10.987,0,0,0-5.122,8.505,3.231,3.231,0,0,0,1.408,3c.869.491,2.431,1.4,2.431,1.4l15.224-9.865a1.774,1.774,0,0,0,1.059-1.473V304a1.774,1.774,0,0,1-1.059,1.479Z",
    transform: "translate(-296.682 -219.466)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    d: "M401.352,315.862a10.971,10.971,0,0,0-5.122,8.505c0,3.064,2.289,4.223,5.122,2.591l13.934-8.05a1.81,1.81,0,0,0,1.065-1.473v-11.1a1.774,1.774,0,0,1-1.065,1.479Z",
    transform: "translate(-298.345 -220.422)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    d: "M404.307,324.972c1.626-.94,2.957-.177,2.957,1.7a6.547,6.547,0,0,1-2.957,5.1c-1.626.94-2.957.177-2.957-1.7A6.506,6.506,0,0,1,404.307,324.972Z",
    transform: "translate(-300.437 -227.869)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    d: "M297.192,244.777l-58.76-61.552a5.205,5.205,0,0,1-1.212-1.975l-2,5.039,58,60.771a7.854,7.854,0,0,1,1.479,2.466l4.016-2.324A7.364,7.364,0,0,0,297.192,244.777Z",
    transform: "translate(-232.564 -169.316)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-1",
    transform: "translate(163.648 9.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-1-2",
    "data-name": "freepik--speech-bubble--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-1-3",
    "data-name": "freepik--speech-bubble--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M338.12,153.217l3.105-5.844-2.5-7.216V135.74l7.647,4.418v4.418l-3.288,5.7a.461.461,0,0,1-.225.2h0Z",
    transform: "translate(-317.242 -93.588)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M302.82,70.071a5.08,5.08,0,0,1,2.295-3.975l1.869-1.076a5.051,5.051,0,0,1,4.584,0L347.746,85.81a5.081,5.081,0,0,1,2.295,3.975V121.3a5.075,5.075,0,0,1-2.295,3.975l-1.869,1.076a5.051,5.051,0,0,1-4.584,0l-14.118-8.109-3.306,5.69a.491.491,0,0,1-.887-.089l-3.466-10.013-14.4-8.28a5.063,5.063,0,0,1-2.295-3.975Z",
    transform: "translate(-302.82 -64.47)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M376.887,137.222a5.075,5.075,0,0,1-2.295,3.975l-1.869,1.076a5.122,5.122,0,0,1-4.193.189c1.076.408,1.9-.2,1.9-1.514V109.435a4.672,4.672,0,0,0-.668-2.259l6.453-3.726a4.684,4.684,0,0,1,.674,2.259Z",
    transform: "translate(-329.666 -80.395)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M303,69.423c.266-.976,1.153-1.283,2.212-.674l36.185,20.8a4.513,4.513,0,0,1,1.615,1.709l6.453-3.72a4.619,4.619,0,0,0-1.615-1.715l-36.2-20.8a5.1,5.1,0,0,0-4.59,0l-1.875,1.082A5.069,5.069,0,0,0,303,69.423Z",
    transform: "translate(-302.893 -64.473)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M342.076,105.242l-26.45-15.271c-.521-.3-.946-.053-.946.544v18.276a2.093,2.093,0,0,0,.946,1.632l26.45,15.271c.52.3.946.059.946-.544v-18.27A2.094,2.094,0,0,0,342.076,105.242Z",
    transform: "translate(-307.665 -74.836)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M340.217,124.8a.467.467,0,0,1-.219-.059l-21.576-12.462a.432.432,0,0,1-.219-.379,2.188,2.188,0,0,0-1.094-1.887.444.444,0,0,1-.219-.379V96.995a.45.45,0,0,1,.219-.379.444.444,0,0,1,.438,0,.875.875,0,0,0,1.307-.757.426.426,0,0,1,.219-.373.414.414,0,0,1,.438,0l21.576,12.456a.438.438,0,0,1,.219.379,2.182,2.182,0,0,0,1.094,1.887.444.444,0,0,1,.213.379v12.645a.438.438,0,0,1-.651.379.869.869,0,0,0-1.307.757.437.437,0,0,1-.219.379A.485.485,0,0,1,340.217,124.8Zm-21.156-13.154,20.854,12.036a1.7,1.7,0,0,1,.739-.828,1.739,1.739,0,0,1,1.088-.225V110.805a3.058,3.058,0,0,1-1.3-2.242L319.593,96.54a1.774,1.774,0,0,1-1.828,1.053v11.829A3.07,3.07,0,0,1,319.061,111.651Z",
    transform: "translate(-308.568 -77.117)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    d: "M337.374,121.944a3.974,3.974,0,0,1-1.964-.591,9.126,9.126,0,0,1-4.14-7.139,3.191,3.191,0,0,1,1.36-2.9,3.094,3.094,0,0,1,3.2.272,9.138,9.138,0,0,1,4.14,7.139,3.143,3.143,0,0,1-1.366,2.9A2.431,2.431,0,0,1,337.374,121.944ZM333.89,111.86a1.579,1.579,0,0,0-.8.207,2.343,2.343,0,0,0-.923,2.147,8.144,8.144,0,0,0,3.679,6.382,2.421,2.421,0,0,0,2.324.278,2.309,2.309,0,0,0,.923-2.153,8.144,8.144,0,0,0-3.685-6.382A3.141,3.141,0,0,0,333.89,111.86Z",
    transform: "translate(-314.443 -83.47)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coin--inject-1",
    transform: "translate(11.566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-1-2",
    "data-name": "freepik--coin--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M67.909,49.951c-2.058-1.183-4.767-1.183-7.825.308C52.862,53.737,46.463,64.04,45.747,73.29c-.4,5.228,1.13,8.99,3.838,10.646.692.42,3.383,1.946,4.022,2.33,2.07,1.224,4.82,1.236,7.925-.254C68.754,82.534,75.178,72.231,75.87,63c.4-5.323-1.183-9.1-3.963-10.711C71.244,51.88,68.589,50.336,67.909,49.951Z",
    transform: "translate(-45.685 -49.099)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M67.909,49.951c-2.058-1.183-4.767-1.183-7.825.308C52.862,53.737,46.463,64.04,45.747,73.29c-.4,5.228,1.13,8.99,3.838,10.646.692.42,3.383,1.946,4.022,2.33,2.07,1.224,4.82,1.236,7.925-.254C68.754,82.534,75.178,72.231,75.87,63c.4-5.323-1.183-9.1-3.963-10.711C71.244,51.88,68.589,50.336,67.909,49.951Z",
    transform: "translate(-45.685 -49.099)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M74.793,73.422,53.034,60.86a31.977,31.977,0,0,0-7.287,17.211c-.4,5.228,1.13,8.99,3.838,10.646.692.42,3.383,1.946,4.022,2.33,2.07,1.224,4.82,1.236,7.925-.254C67.3,88.007,72.552,80.881,74.793,73.422Z",
    transform: "translate(-45.685 -53.904)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    d: "M46.96,79.75a26.9,26.9,0,0,0-1.183,6.039c-.4,5.228,1.13,8.99,3.838,10.646.692.42,3.383,1.946,4.022,2.33,2.07,1.224,4.82,1.236,7.925-.254a22.239,22.239,0,0,0,7.31-6.11Z",
    transform: "translate(-45.697 -61.622)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M66.79,54.137c-7.228,3.478-13.645,13.781-14.343,23.013s4.6,13.893,11.829,10.421S77.921,73.791,78.619,64.565,74.041,50.666,66.79,54.137Z",
    transform: "translate(-48.422 -50.689)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M66.79,54.137c-7.228,3.478-13.645,13.781-14.343,23.013s4.6,13.893,11.829,10.421S77.921,73.791,78.619,64.565,74.041,50.666,66.79,54.137Z",
    transform: "translate(-48.422 -50.689)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M77.142,70.9A22.031,22.031,0,0,1,73.9,79.639a18.071,18.071,0,0,1-6.092,6.24c-2.3,1.272-4.365,1.272-5.808,0s-2.046-3.62-1.686-6.606a21.884,21.884,0,0,1,3.241-8.742,18.084,18.084,0,0,1,6.1-6.24c2.295-1.272,4.359-1.272,5.8,0S77.5,67.911,77.142,70.9Z",
    transform: "translate(-51.618 -54.916)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M77.142,70.9A22.031,22.031,0,0,1,73.9,79.639a18.071,18.071,0,0,1-6.092,6.24c-2.3,1.272-4.365,1.272-5.808,0s-2.046-3.62-1.686-6.606a21.884,21.884,0,0,1,3.241-8.742,18.084,18.084,0,0,1,6.1-6.24c2.295-1.272,4.359-1.272,5.8,0S77.5,67.911,77.142,70.9Z",
    transform: "translate(-51.618 -54.916)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M75.749,55.905c-2-1.774-4.885-1.869-8.115-.319-3.371,1.626-6.683,4.85-9.315,9.073a30.051,30.051,0,0,0-4.59,13.231c-.308,4.14.591,7.375,2.62,9.138s4.879,1.875,8.115.319c3.371-1.621,6.683-4.838,9.315-9.061a29.992,29.992,0,0,0,4.584-13.237C78.706,60.915,77.754,57.674,75.749,55.905Zm-2.957,4.8c1.443,1.272,2.046,3.62,1.692,6.606a22.031,22.031,0,0,1-3.259,8.712,18.072,18.072,0,0,1-6.092,6.24c-2.3,1.272-4.365,1.272-5.808,0s-2.046-3.62-1.686-6.606a21.883,21.883,0,0,1,3.241-8.742,18.084,18.084,0,0,1,6.1-6.24C69.273,59.4,71.337,59.4,72.792,60.708Z",
    transform: "translate(-48.947 -51.303)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M70.354,65.395c4.312-2.366,7.275.219,6.606,5.826s-4.7,12.083-9.02,14.473-7.275-.189-6.606-5.808S66.037,67.8,70.354,65.395Z",
    transform: "translate(-52.04 -55.399)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    d: "M70.354,65.395c4.312-2.366,7.275.219,6.606,5.826s-4.7,12.083-9.02,14.473-7.275-.189-6.606-5.808S66.037,67.8,70.354,65.395Z",
    transform: "translate(-52.04 -55.399)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    d: "M70.354,65.395c4.312-2.366,7.275.219,6.606,5.826s-4.7,12.083-9.02,14.473-7.275-.189-6.606-5.808S66.037,67.8,70.354,65.395Z",
    transform: "translate(-52.04 -55.399)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    d: "M75.724,70.121c-.668,5.607-4.732,12.083-9.02,14.473-1.774.988-3.336,1.118-4.5.538a7.717,7.717,0,0,1-.869-5.276c.662-5.6,4.7-12.06,9.02-14.467,1.774-.988,3.336-1.118,4.5-.538A7.752,7.752,0,0,1,75.724,70.121Z",
    transform: "translate(-52.04 -55.394)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    d: "M75.724,70.121c-.668,5.607-4.732,12.083-9.02,14.473-1.774.988-3.336,1.118-4.5.538a7.717,7.717,0,0,1-.869-5.276c.662-5.6,4.7-12.06,9.02-14.467,1.774-.988,3.336-1.118,4.5-.538A7.752,7.752,0,0,1,75.724,70.121Z",
    transform: "translate(-52.04 -55.394)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    "data-name": "Path 2237",
    d: "M73.649,75.42a2.759,2.759,0,0,0-2.058,0l-.692.248a2.277,2.277,0,0,1,.9-.9c1.035-.627,1.473-.095,1.579.426l2.5-2.242a2.413,2.413,0,0,0-.254-.692,1.544,1.544,0,0,0-.455-.461c-.118-.071-1.822-1-1.987-1.047a2.023,2.023,0,0,0-.467-.065v-.3L71.07,69.5l-1.964,1.183v.355l.041,1.218A5.123,5.123,0,0,0,67.131,74.5c-.047.077-.083.148-.124.219a4.968,4.968,0,0,0-.591,2.525h0A1.774,1.774,0,0,0,67.1,78.8c.035,0,1.366.727,1.585.869l.154.083.118.047h0l.136.035h.272a3.514,3.514,0,0,0,.881.012,1.9,1.9,0,0,0,.455-.112l.657-.2.2-.065a2.449,2.449,0,0,1-.9.858,2.537,2.537,0,0,1-.591.284l-.929-.538-2.366,2.135a1.774,1.774,0,0,0,.662.917c.29.2,1.437.787,1.692.934a1.49,1.49,0,0,0,.692.213v.349l1.615.887,1.987-1.183-.065-1.567a7.257,7.257,0,0,0,1.952-2.177h0a5,5,0,0,0,.657-2.638,1.856,1.856,0,0,0-.668-1.615C74.9,76.095,73.856,75.562,73.649,75.42Z",
    transform: "translate(-54.152 -57.434)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    "data-name": "Path 2238",
    d: "M73.649,75.42a2.759,2.759,0,0,0-2.058,0l-.692.248a2.277,2.277,0,0,1,.9-.9c1.035-.627,1.473-.095,1.579.426l2.5-2.242a2.413,2.413,0,0,0-.254-.692,1.544,1.544,0,0,0-.455-.461c-.118-.071-1.822-1-1.987-1.047a2.023,2.023,0,0,0-.467-.065v-.3L71.07,69.5l-1.964,1.183v.355l.041,1.218A5.123,5.123,0,0,0,67.131,74.5c-.047.077-.083.148-.124.219a4.968,4.968,0,0,0-.591,2.525h0A1.774,1.774,0,0,0,67.1,78.8c.035,0,1.366.727,1.585.869l.154.083.118.047h0l.136.035h.272a3.514,3.514,0,0,0,.881.012,1.9,1.9,0,0,0,.455-.112l.657-.2.2-.065a2.449,2.449,0,0,1-.9.858,2.537,2.537,0,0,1-.591.284l-.929-.538-2.366,2.135a1.774,1.774,0,0,0,.662.917c.29.2,1.437.787,1.692.934a1.49,1.49,0,0,0,.692.213v.349l1.615.887,1.987-1.183-.065-1.567a7.257,7.257,0,0,0,1.952-2.177h0a5,5,0,0,0,.657-2.638,1.856,1.856,0,0,0-.668-1.615C74.9,76.095,73.856,75.562,73.649,75.42Z",
    transform: "translate(-54.152 -57.434)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(12.607 13.249)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M76.2,80.3a2.738,2.738,0,0,1,2.029-.035c-.349-.213-1.366-.733-1.585-.869a2.759,2.759,0,0,0-2.058,0l-.692.237h0a1.372,1.372,0,0,0-.154.668C73.793,81.3,74.923,80.681,76.2,80.3Z",
    transform: "translate(-69.753 -74.642)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M72.1,94.308v.349l1.615.887h0L73.667,94a3.549,3.549,0,0,1-1.567.308Z",
    transform: "translate(-69.084 -80.692)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M68.585,91.911,67,91a1.774,1.774,0,0,0,.662.917c.278.189,1.325.727,1.644.911A1.774,1.774,0,0,1,68.585,91.911Z",
    transform: "translate(-67 -79.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M75.811,85.994a.384.384,0,0,0-.367-.225,4.607,4.607,0,0,0-1.325.308h-.053a2.449,2.449,0,0,1-.9.858,2.538,2.538,0,0,1-.591.284l.7.384c.142.591.657.751,1.538.219s1.106-1.076,1.088-1.55A.816.816,0,0,0,75.811,85.994Z",
    transform: "translate(-69.276 -77.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M70.97,71.5l1.615.893.059,1.579-1.621-.893Z",
    transform: "translate(-68.622 -71.5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M71.863,72.544l.047,1.224a5.062,5.062,0,0,0-2.023,2.242c-.047.077-.083.154-.118.225a4.962,4.962,0,0,0-.591,2.525h0c.035.934.349,1.414.8,1.621l.118.047h0l.136.035H70.5a3.514,3.514,0,0,0,.869,0,1.9,1.9,0,0,0,.455-.112l.657-.2.248-.083a4.229,4.229,0,0,1,1.325-.308.384.384,0,0,1,.367.225.816.816,0,0,1,.059.3,1.877,1.877,0,0,1-1.088,1.55c-.822.5-1.4.4-1.538-.219l-2.366,2.153c.426,1.183,1.449,1.5,3,.84l.065,1.567,1.987-1.183-.065-1.567a7.257,7.257,0,0,0,1.952-2.177h0a5,5,0,0,0,.657-2.638c-.083-2.076-1.372-1.993-2.744-1.6-1.278.384-2.407,1.005-2.449,0a1.839,1.839,0,0,1,1.059-1.567c1.035-.627,1.473-.095,1.579.426l2.5-2.242a2.413,2.413,0,0,0-.272-.757,1.419,1.419,0,0,0-.828-.591,3.17,3.17,0,0,0-2.035.331L73.8,71l-1.952,1.183Z",
    transform: "translate(-55.282 -58.047)",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M76.8,94.329l-1.987,1.195L74.75,93.95,75,95.18Z",
    transform: "translate(-57.56 -67.423)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M72.076,88.9,69.71,91.053l2.23-1.887s.284,1.106,1.692-.047c-.881.532-1.4.4-1.538-.219",
    transform: "translate(-55.5 -65.36)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M80.734,74.453a2.413,2.413,0,0,0-.266-.692,1.42,1.42,0,0,0-.828-.591,1.6,1.6,0,0,1,.9,1.343L78.25,76.725Z",
    transform: "translate(-58.989 -58.933)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    d: "M75.729,72.589l-.213-1.307-1.816.911,1.964-1.183Z",
    transform: "translate(-57.131 -58.051)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    d: "M66.206,103.485c5.015-2.253,9.463-8.765,9.463-8.765-2.662,4.223-5.974,7.44-9.345,9.037-3.235,1.556-6.116,1.443-8.115-.319C58.21,103.462,61.108,105.78,66.206,103.485Z",
    transform: "translate(-50.802 -67.738)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M59.19,64.753c2.667-4.732,6.405-8.712,10.38-10.646,4.14-1.987,7.636-1.307,9.741,1.366,0,0-3.549-4.182-9.765-.958S59.19,64.753,59.19,64.753Z",
    transform: "translate(-51.202 -50.676)",
    fill: "#f5f5f5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletAmico);
export default __webpack_public_path__ + "static/media/Wallet-amico.6ee2ae6e54d814783762a705b5046b0f.svg";
export { ForwardRef as ReactComponent };